module.exports = __webpack_public_path__ + "img/login.e9ba3dda.svg";